import { CALCULATION_STATUS_LABELS, PHASE_LABELS, READINESS_LABELS, STATUS_LABELS } from './powerBalance.constants';

const numeric = (value) => value === null || value === undefined || value === '' ? null : Number(value);
const formatScaled = (value, divisor, unit, digits = 2) => {
  const number = numeric(value);
  return number === null || !Number.isFinite(number) ? '—' : `${new Intl.NumberFormat('fr-FR', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(number / divisor)} ${unit}`;
};
export const formatPowerW = (value) => formatScaled(value, 1000, 'kW');
export const formatApparentPowerVA = (value) => formatScaled(value, 1000, 'kVA');
export const formatReactivePowerVar = (value) => formatScaled(value, 1000, 'kvar');
export const formatCurrentA = (value) => formatScaled(value, 1, 'A', 1);
export const formatPowerFactor = (value) => formatScaled(value, 1, '', 2).trim();
export const formatPercent = (value) => formatScaled(numeric(value) === null ? null : numeric(value) * 100, 1, '%', 1);
export const getPhaseLabel = (value) => PHASE_LABELS[value] || String(value || '').toUpperCase() || '—';
export const getStatusLabel = (value) => STATUS_LABELS[value] || value || '—';
export const getReadinessLabel = (value) => READINESS_LABELS[value] || value || '—';
export const getCalculationStatusLabel = (value) => CALCULATION_STATUS_LABELS[value] || value || '—';
export const getReadinessTone = (value) => ({ ready: 'success', ready_with_warnings: 'warning', incomplete: 'warning', blocked: 'danger' }[value] || 'neutral');
export const getCalculationStatusTone = (value) => ({ valid: 'success', valid_with_warnings: 'warning', invalid: 'danger' }[value] || 'neutral');
export const getApiErrorMessage = (error, context = 'load') => {
  const remote = error?.body?.details?.remote;
  const detail = remote?.detail ?? remote?.details ?? error?.body?.details;
  const items = Array.isArray(detail) ? detail : Array.isArray(detail?.errors) ? detail.errors : [];
  if (items.length) {
    const messages = items.map((item) => {
      const location = Array.isArray(item?.loc) ? item.loc.filter((part) => part !== 'body').join(' › ') : item?.field;
      return [location, item?.msg || item?.message].filter(Boolean).join(' : ');
    }).filter(Boolean);
    if (messages.length) return `Le calcul n’a pas pu être effectué — ${messages.length} donnée(s) à corriger. ${messages.join(' · ')}`;
  }
  if (typeof detail === 'string') return detail;
  if (error?.status === 403) return "Vous n’avez pas les droits nécessaires.";
  if (error?.status === 409 && error?.body?.code === 'POWER_BALANCE_CALCULATION_STALE') return 'Le bilan a été modifié depuis le dernier calcul.';
  if (context === 'calculate' && [500, 502, 503, 504].includes(error?.status)) return 'Le moteur de calcul est temporairement indisponible.';
  return error?.message || (context === 'calculate' ? 'Une erreur est survenue lors du calcul.' : 'Une erreur est survenue.');
};
